export enum ThemeIndex {
  Theme0,
  Theme1,
  Theme2,
  Theme3,
  Theme4,
  Theme5,
  Theme6,
  Theme7,
  Theme8,
  Theme9
}

export interface ITheme {
  index: ThemeIndex;
  name: string;
  icon: string;
  sidebar: string;
  syntax: string;
  text: string;
  ui: string;
}

export const newTheme = () => ThemeHelper.getTheme(0);

export const themes: ITheme[] = [];

// ---------------------------------------------- add theme
const addTheme = (
  index: ThemeIndex,
  name: string,
  icon: string,
  sidebar: string,
  syntax: string,
  text: string,
  ui: string
): void => {
  themes[index] = { index, name, icon, sidebar, syntax, text, ui };
};

addTheme(ThemeIndex.Theme0, "Black", "#000", "#fff", "#fff", "#000", "#000");
addTheme(
  ThemeIndex.Theme1,
  "Red",
  "#f44336",
  "#ffebee",
  "#fff",
  "#000",
  "#e53935"
);
addTheme(
  ThemeIndex.Theme2,
  "Pink",
  "#ec407a",
  "#fce4ec",
  "#fff",
  "#000",
  "#e91e63"
);
addTheme(
  ThemeIndex.Theme3,
  "Deep Purple",
  "#7c4dff",
  "#ede7f6",
  "#fff",
  "#000",
  "#6200ea"
);
addTheme(
  ThemeIndex.Theme4,
  "Indigo",
  "#283593",
  "#e8eaf6",
  "#fff",
  "#000",
  "#1a237e"
);
addTheme(
  ThemeIndex.Theme5,
  "Light Blue",
  "#0277bd",
  "#e3f2fd",
  "#fff",
  "#000",
  "#0277bd"
);
addTheme(
  ThemeIndex.Theme6,
  "Teal",
  "#009688",
  "#e0f2f1",
  "#fff",
  "#000",
  "#009688"
);
addTheme(
  ThemeIndex.Theme7,
  "Amber",
  "#ff9100",
  "#fff9c4",
  "#fff",
  "#000",
  "#ff9100"
);
addTheme(
  ThemeIndex.Theme8,
  "Brown",
  "#5d4037",
  "#efebe9",
  "#fff",
  "#4e342e",
  "#4e342e"
);
addTheme(
  ThemeIndex.Theme9,
  "Dark Grey",
  "#424242",
  "#eeeeee",
  "#fff",
  "#000",
  "#424242"
);

// ---------------------------------------------- helper class
class ThemeHelper {
  static getTheme = (index: ThemeIndex): ITheme =>
    index ? themes[index] : themes[0];
}

export default ThemeHelper;
